import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Tabs, Alert, DatePicker, Col, Row, Tooltip, Popover } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import '../css/form.css';
import EditableTable from '../components/EditableTable';
import { entriesColumns } from '../utils/tableMockData';
import { MdPublish } from "react-icons/md";
import { FcInfo } from "react-icons/fc";
import { FaCloudArrowUp } from "react-icons/fa6";
import EventEmitter from '../utils/eventEmitter';
import dayjs from 'dayjs';
import { Badge } from 'flowbite-react';
import useVendorBills from '../apis/vendorBillAPI';
import DebitNoteModal from '../modals/DebitNoteModal';
import InvoiceTable from '../components/InvoiceTable';
import EntryTable from '../components/EntryTable';
import Ribbon, { RibbonText } from '../../globalComponents/Ribbon';
import RegisterPaymentModal from '../modals/RegisterPaymentModal';
// import customParseFormat from 'dayjs/plugin/customParseFormat';
// dayjs.extend(customParseFormat);

export const invoiceColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Label',
    dataIndex: 'label',
    key: 'label',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Account',
    dataIndex: 'account_id',
    key: 'account',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Analytics',
    dataIndex: 'analytics',
    key: 'analytics',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '10%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '10%'
  },
  {
    title: 'Taxes',
    dataIndex: 'taxes',
    key: 'taxes',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '15%'
  },
  {
    title: 'Subtotal',
    dataIndex: 'subtotal',
    key: 'subtotal',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    width: '10%'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  },
];


const VendorBillChanges = () => {
  const { journals, accounts, taxes, entry, analytics, bill, contacts } = useLoaderData();
  bill['bill_date'] = bill.bill_date ? dayjs(bill['bill_date'], 'YYYY-MM-DD') : '';
  bill['due_date'] = bill.due_date ? dayjs(bill['due_date'], 'YYYY-MM-DD') : '';
  bill['accounting_date'] = bill.accounting_date ? dayjs(bill['accounting_date'], 'YYYY-MM-DD') : '';
  // console.log(bill)
  const [invoiceLines, setInvoiceLines] = useState(bill.line_items ? bill.line_items : []);
  const [journalEntries, setJournalEntries] = useState(entry.transactions ? entry.transactions : []);
  const [formValue, setFormValue] = useState(bill.status ? {status: bill.status} :{status: 'null'});
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const params = useParams();
  const [tax, setTax] = useState([]);
  const [alert, setAlert] = useState({message: '', status: ''});
  const navigate = useNavigate();
  const { save, postBill, saveBillDebitNote, createAndPost, update } = useVendorBills();
  const [journalDefaultAccount, setJournalDefaultAccount] = useState({});
  const [products, setProducts] = useState([]);
  const onChangeJournal = opt => {
    setJournalDefaultAccount(opt);
  }

  const handleCreate = () => {
    let data = {...form.getFieldsValue()};
    data['bill_date'] = new Date(dayjs(data.bill_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['accounting_date'] = new Date(data['accounting_date']).toLocaleDateString();
    data['line_items'] = invoiceLines;
    
    let journal_code = journals.find(journal => journal._id === data.journal_id).code;
    const journalEntry = {
      reference: data.bill_reference,
      accounting_date: data.accounting_date,
      journal_code: journal_code,
      journal_id: data.journal_id,
      transactions: [...journalEntries],
    };
    // console.log(journalEntry)
    
    save({bill: data, entry: journalEntry}, success);
  }

  const handleConfirm = () => {
    let data = {...form.getFieldsValue()};
    data['bill_date'] = new Date(dayjs(data.bill_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['accounting_date'] = new Date(data['accounting_date']).toLocaleDateString();
    data['line_items'] = invoiceLines;
    data['status'] = 'posted';
    let journal_code = journals.find(journal => journal._id === data.journal_id).code;
    const journalEntry = {
      reference: data.bill_reference,
      accounting_date: data.accounting_date,
      journal_code: journal_code,
      journal_id: data.journal_id,
      transactions: [...journalEntries],
      status: 'posted'
    };
    // let analyticItems = [];
    // invoiceLines.forEach(entryLine => {
    //   if (entryLine.analytics) {
    //     entryLine.analytics.forEach(analyticId => {
    //       let itemObject = {
    //         description: data.bill_reference, 
    //         analytic_account_id: analyticId,
    //         date: data.bill_date,
    //         amount: entryLine.subtotal,
    //         reference: '',
    //         quantity: entryLine.quantity,
    //         product: entryLine.product_id,
    //         journal_item_number: entry._id,
    //         account_id: entryLine.account_id
    //       };
    //       analyticItems.push(itemObject);
    //     });
    //   }
    // });
    postBill(bill.number.replaceAll('/', '-'), {bill: data, entry: journalEntry}, success);
  }

  useEffect(() => {
    fetch('http://localhost:4900/inventory/products', {method: 'GET'})
    .then(res => res.json())
    .then(res => setProducts(res))
    .catch(err => console.log(err))
  },[])
 
  useEffect(() => {
    EventEmitter.subscribe('saved_bill_response', data => {
      navigate('/accounting/bills/'+data.number.replaceAll('/', '-'));
      setFormValue({...formValue, status: 'draft'});
    });

    EventEmitter.subscribe('bill_posted', data => {
      // navigate('/accounting/bills/'+data.number);
      setFormValue({...formValue, status: data.status});
    });

    EventEmitter.subscribe('creating_debit_note', async data_ => {
      let data = {...form.getFieldsValue()};
      data['bill_date'] = new Date(dayjs(data.bill_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
      data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
      data['accounting_date'] = new Date(dayjs(data.accounting_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
      data['line_items'] = invoiceLines;
      data['status'] = 'draft';
      data['bill_reference'] = `Reversal of ${data.payment_reference}`;
      const number_ = data.bill_reference.split(' ')[2];
      // let journal_code = journals.find(journal => journal._id === data.journal_id).code;
    
      let entries = [];
      entry.transactions.forEach((entry, idx) => {
        let obj = {...entry};
        if (obj.type === 'credit') {
          obj.type = 'debit';
        }else if (obj.type === 'debit'){
          obj.type = 'credit';
        }
        entries.push(obj);
      });
      
      let journal_code = journals.find(journal => journal._id === data.journal_id).code;
      const journalEntry = {
        reference: data.bill_reference,
        accounting_date: data.accounting_date,
        journal_code: journal_code,
        journal_id: data.journal_id,
        transactions: [...journalEntries],
        status: 'posted'
      };
      // let analyticItems = [];
      // invoiceLines.forEach(entryLine => {
      //   if (entryLine.analytics) {
      //     entryLine.analytics.forEach(analyticId => {
      //       let itemObject = {
      //         description: data.bill_reference, 
      //         analytic_account_id: analyticId,
      //         date: data.bill_date,
      //         amount: entryLine.subtotal,
      //         reference: '',
      //         quantity: entryLine.quantity,
      //         product: entryLine.product_id,
      //         journal_item_number: entry._id,
      //         account_id: entryLine.account_id
      //       };
      //       analyticItems.push(itemObject);
      //     });
      //   }
      // });
      if (data_.reversal_date === 'specific') {
        data['refund_date'] = new Date(data_['refund_date']).toLocaleDateString();
      }else if (data_.reversal_date === "journal_entry_date") {
        data['refund_date'] = data['bill_date'];
      };
      data['reason'] = data_.reason;
      // console.log(journalEntry)
      switch (data_.debit_method) {
        case "partial_refund":
          // create new credit note draft
          const number = await saveBillDebitNote({bill: data, entry: journalEntry}, success)
          await update(number_.replaceAll('/', '-'), {reversed: true}, success);
          if (number) navigate('/accounting/debit-notes/'+number.replaceAll('/', '-'));
          break;
        case "full_refund":
          // create and validatejournalEntry
          data['status'] = 'posted';
          journalEntry.status = 'posted';
          const createdNumber = await createAndPost({invoice: data, entry: journalEntry}, success)
          await update(number_.replaceAll('/', '-'), {reversed: true}, success);
          if (createdNumber) navigate('/accounting/debit-notes/'+createdNumber.replaceAll('/', '-'));
          break;
        case "full_refund_new_invoice":
          // create and validate credit note to posted and draft new invoice
          data['status'] = 'posted';
          journalEntry.status = 'posted';
          const createdNumber_ = await createAndPost({invoice: data, entry: journalEntry}, success)
          await update(number_.replaceAll('/', '-'), {reversed: true}, success);
          if (createdNumber_) navigate('/accounting/bills/new');
          break;
      }
    });


    return () => {
      EventEmitter.unsubscribe('saved_bill_response');
      EventEmitter.unsubscribe('bill_posted');
      EventEmitter.unsubscribe('creating_debit_note');
    }
  }, [])

  const handleAddCreditNote = () => {
    EventEmitter.dispatch('invoice_debit_note', true);
  }

  const handleRegisterPayment = () => {
    EventEmitter.dispatch('register_payment', {
      open: true,
      number: bill.number,
      amount: invoiceLines.reduce((prev, current) => (current.subtotal + prev), 0),
      partner_type: 'vendor',
      credit_note: false,
      partner_id: bill.vendor_id
    });
  }

  const viewPayment = () => {
    navigate(`/accounting/bills/${params.action}/${bill.payment.number.replaceAll('/', '-')}`, {
      state: {is_customer: false}
    });
  }

  return (
    <div className='container mx-auto' style={{ maxWidth: '1200px' }}>
      {alert.message !== '' && (
        <Alert message={alert.message} type={alert.status} closable showIcon />
      )}
      <div className='flex justify-between mb-3'>
        <div className='flex '>
          <h3 className='font-bold'>
            <Link to={'/accounting/bills'} className='whitespace-nowrap hover:underline font-medium text-sky-600 dark:text-white'>Bills</Link> / {params.action}
          </h3>
          <Tooltip
            title='save manually'
            placement='rightBottom'
            className='ms-1'
          >
            <Button onClick={handleCreate} type='text' htmlType='button'
              disabled={formValue.status === 'posted' || formValue.status === 'draft' ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
      </div>
      <div className='flex justify-between align-center'>
        <div>
          {formValue.status === 'draft' && <div>
            <Button htmlType='button' onClick={handleConfirm} >CONFIRM</Button> 
            <Button htmlType='button' className='mx-1'>CANCEL</Button>
          </div>}
          {(formValue.status === 'posted' && bill.payment_status === undefined) ? 
          <div>
            <Button htmlType='button' >SEND & PRINT</Button> 
            {!bill.reversed && <><Button htmlType='button' onClick={handleRegisterPayment} className='mx-1'>REGISTER PAYMENT</Button>
            <Button htmlType='button' className='mx-1'>PREVIEW</Button>
            <Button htmlType='button' onClick={handleAddCreditNote} className='mx-1'>ADD DEBIT NOTE</Button>
            <Button htmlType='button' className='mx-1'>RESET TO DRAFT</Button></>}
          </div>:
            (formValue.status === 'posted' && bill.payment_status !== undefined) &&
            <Button htmlType='button' onClick={handleAddCreditNote} className='mx-1'>ADD DEBIT NOTE</Button>
          }
          
        </div>
        {formValue.status !== 'null' && (
          <div id='status-container '>
            <ul className='inner-wrapper'>
              <li
                className={
                  formValue.status === 'draft'
                    ? 'draft-disabled first draft draft-status'
                    : 'first draft-status draft-transparent'
                }
              >
                DRAFT
              </li>
              <li
                className={
                  formValue.status === 'posted'
                    ? 'posted posted-status'
                    : 'posted-status posted-transparent'
                }
              >
                POSTED
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className='mt-3 bg-white'>
        <div className='relative'>
          {bill.payment_status !== undefined && <Ribbon text={bill.payment_status} className={"bg-[#24ad32]"}/>}

            {/* <RibbonText text={'Paid'} className={"text-green-600 bg-blue-500"}/> */}
            {/* <RibbonText text={'In Payment'} className={"bg-[#24ad32]"}/> */}
          {/* </Ribbon> */}
        </div>
        <Form 
          form={form}
          className='shadow p-3' 
          initialValues={bill.status ? bill : {
            auto_post: false,
            to_check: false
          }}  
          labelAlign='left'
          labelCol={{span: 10}}
          autoComplete="off"
          variant='borderless'
          disabled={formValue.status === 'posted' ? true : false}
        >
          <Row>  
            <Col md={{span: 11}}>
              <Form.Item labelCol={{span: 7}} label='Vendor' name="vendor_id" className='font-bold mb-2 ' required >
                <Select options={contacts.map(contact => ({ value: contact._id, label: contact.name}))} className='font-normal'  placeholder='Select name here' />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label='Vendor Address' name="vendor_address" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' placeholder='Enter address here'/>
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label='Bill Reference' name="bill_reference" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' disabled={formValue.status === 'draft' ? true : false} placeholder='Enter reference'/>
              </Form.Item>
            </Col>
            <Col md={{span: 11}}>
              <Form.Item labelCol={{span: 7}} label="Bill Date" name="bill_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label="Accounting Date" name="accounting_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label='Payment Reference' name="payment_reference" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full'  />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label="Due Date" name="due_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label='Journal' name={'journal_id'} className='font-bold mb-2' required >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name, account: journal.default_account}))} onChange={(_, opt)=>onChangeJournal(opt)}  placeholder='select journal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type='card'
            items={[
              {
                key: '1',
                label: 'Invoice Lines',
                children: <>
                  <InvoiceTable name={'bill'} dataSource={invoiceLines} default_account={journalDefaultAccount} invoiceNumber={form.getFieldValue('payment_reference')} setInvoiceLines={setInvoiceLines} entries={journalEntries} setJournalEntries={setJournalEntries} columns={invoiceColumns} accounts={accounts} taxes={taxes} setTax={setTax} tax={tax} products={products.length > 0 ? products : []} analytics={analytics} status={formValue.status}/>
                  {bill.payment && 
                  <Row className='flex justify-end'>
                    <Col md={{span: 6}}>
                      <Form.Item labelCol={{span: 17 }} colon={false} label={
                        <div className='flex items-center'>
                          <Popover 
                            trigger={'click'}
                            placement='left'
                            title={<h3 className='ps-2 bg-slate-300'>Payment Info</h3>}
                            content={
                              <div className='payment-info-container ps-2 m-0'>
                                <div className='payment-info-lines'>
                                  <p>Amount:</p>
                                  <span>{bill.payment.amount}</span>
                                </div>
                                <div className='payment-info-lines'>
                                  <p>Memo:</p>
                                  <span>{bill.payment.memo}</span>
                                </div>
                                <div className='payment-info-lines'>
                                  <p>Date:</p>
                                  <span>{bill.payment.date}</span>
                                </div>
                                <div className='payment-info-lines'>
                                  <p>Payment Journal:</p>
                                  <span>{bill.payment.journal}</span>
                                </div>
                                <div className='flex justify-end'>
                                  <Button type='text' className='text-[#05bcc4]' onClick={viewPayment} disabled={false}>View</Button>
                                </div>
                              </div>
                            }>
                            <FcInfo />
                          </Popover>
                          <span className='ms-4'>Paid on{bill.payment.date}</span>

                        </div>
                      }>
                        <span className='text-end'>GHc {invoiceLines.reduce((prev, current) => (current.subtotal + prev), 0).toFixed(2)}</span>
                      </Form.Item>
                    </Col>
                  </Row>}
                </>
              },
              {
                key: '2',
                label: 'Journal Items',
                children: <EntryTable name={'journal entries'} dataSource={journalEntries} setJournalEntries={setJournalEntries} columns={entriesColumns} accounts={accounts} analytics={analytics} taxes={taxes} setTax={setTax} tax={tax} status={formValue.status}/>
              },
              {
                key: '3',
                label: 'Other Info',
                active: true,
                children: 
                  <Form 
                    form={form}
                    initialValues={bill.status ? {auto_post: bill.auto_post, to_check: bill.to_check} : {
                      auto_post: false,
                      to_check: false
                    }}  
                    labelAlign='left'
                    labelCol={{span: 10}}
                    autoComplete="off"
                    variant='borderless'
                  
                  >
                  <Row>
                    {/* <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-md bg-transparent	">INVOICE</Badge>
                      <Form.Item labelCol={{span: 5}} label='Salesperson' name={'salesperson'} className='font-bold ms-2'>
                        <Select options={[]} style={{width: '200px'}}/>
                      </Form.Item>
                    </Col> */}
                    <Col  md={{span: 10}}>
                      <Badge className="text-slate-500 text-md bg-transparent	">ACCOUNTING</Badge>
                      <Form.Item labelCol={{span: 7}} label='Auto-post' name={'auto_post'} valuePropName='checked' className='font-bold ms-2'>
                        <Checkbox />
                      </Form.Item>
                      <Form.Item labelCol={{span: 7}} label='To Check' name={'to_check'} valuePropName='checked' className='font-bold ms-2'>
                        <Checkbox />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              }
            ]}
          />
        </Form>
      </div>
      <RegisterPaymentModal />
      <DebitNoteModal />
    </div>
  )
}
export default VendorBillChanges;
